if (!customElements.get('progress-bar')) {

  class ProgressBar extends HTMLElement {

    constructor() {
      super();

      // Options
      this.options = {
        "gift_threshold": 7500,
        "giftcards_value": 0,
        "cart_total": 0,
        "translations": {
          "gift_threshold_text": "{{ html }} away from a free gift",
          "shipping_threshold_text": "{{ html }} away from free shipping",
          "reached_text": "You have reached free shipping"
        }
      }

      // Get options from element data and combine with this.options
      if (this?.dataset?.options) {
        const dataOptions = JSON.parse(this.dataset.options);
        this.options = {
          ...this.options,
          ...dataOptions
        };
      }

      // elements
      this.elements = {
        content: this.querySelector('[data-progress-bar-content]'),
        header: this.querySelector('[data-progress-bar-header]'),
      }

    }

    /*
      Update the progress bar
      @param state {object}: state object received from cart update (cart.js)
    */
    update(state) {

      // get total price from state
      const { total_price } = state;
      const cart_total = total_price - this.options.giftcards_value;

      // type
      let type = 'gift';
      if (
        (!this.options.gift_threshold || cart_total >= this.options.gift_threshold)
        && (!this.options.shipping_threshold || cart_total >= this.options.shipping_threshold)
      )

      // free gift not reached
      if (type == 'gift') {
        let amount = this.options.gift_threshold - cart_total;
        if ( amount > 0 ) {
          let price_to_go = this.options.gift_threshold - cart_total,
              price_to_go_html = `${(Math.round(price_to_go) / 100).toFixed(2)}`,
              header_text = this.options.translations.gift_threshold_text.replace('{{ html }}', price_to_go_html);
          this.elements.header.innerText = header_text
        } else if ( amount < 0 ) {
          this.elements.header.innerText = this.options.translations.reached_text;
        }
      }
      // free shipping and gift reached
      else {
        this.elements.header.innerText = this.options.translations.reached_text;
      }
    }
  }

  window.ProgressBar = ProgressBar;

  customElements.define('progress-bar', ProgressBar);

}
